// extracted by mini-css-extract-plugin
export var solutions_suptitle = "styles-module--solutions_suptitle--PRrGd";
export var solutions_title = "styles-module--solutions_title--KHQkZ";